/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index'
import { Route as AuthenticatedScheduleRouteImport } from './routes/_authenticated.schedule'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated.reports'
import { Route as AuthenticatedExceptionsRouteImport } from './routes/_authenticated.exceptions'
import { Route as AuthenticatedDispatchRouteImport } from './routes/_authenticated.dispatch'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedCoverageMapRouteImport } from './routes/_authenticated.coverage-map'
import { Route as AuthenticatedRoutesIndexRouteImport } from './routes/_authenticated.routes.index'
import { Route as AuthenticatedPatientsIndexRouteImport } from './routes/_authenticated.patients.index'
import { Route as AuthenticatedOrdersIndexRouteImport } from './routes/_authenticated.orders.index'
import { Route as AuthenticatedDriversIndexRouteImport } from './routes/_authenticated.drivers.index'
import { Route as AuthenticatedAuditIndexRouteImport } from './routes/_authenticated.audit.index'
import { Route as AuthenticatedRoutesRouteIdRouteImport } from './routes/_authenticated.routes.$routeId'
import { Route as AuthenticatedPatientsPatientIdRouteImport } from './routes/_authenticated.patients.$patientId'
import { Route as AuthenticatedOrdersUploadRouteImport } from './routes/_authenticated.orders.upload'
import { Route as AuthenticatedOrdersOrderIdRouteImport } from './routes/_authenticated.orders.$orderId'
import { Route as AuthenticatedDriversNewRouteImport } from './routes/_authenticated.drivers.new'
import { Route as AuthenticatedDriversDriverIdRouteImport } from './routes/_authenticated.drivers.$driverId'
import { Route as AuthenticatedAdminPharmacyIndexRouteImport } from './routes/_authenticated.admin.pharmacy.index'
import { Route as AuthenticatedRoutesRouteIdBuildRouteImport } from './routes/_authenticated.routes.$routeId_.build'
import { Route as AuthenticatedAdminPharmacyPharmacyIdRouteImport } from './routes/_authenticated.admin.pharmacy.$pharmacyId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScheduleRoute = AuthenticatedScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExceptionsRoute = AuthenticatedExceptionsRouteImport.update({
  id: '/exceptions',
  path: '/exceptions',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDispatchRoute = AuthenticatedDispatchRouteImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCoverageMapRoute =
  AuthenticatedCoverageMapRouteImport.update({
    id: '/coverage-map',
    path: '/coverage-map',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutesIndexRoute =
  AuthenticatedRoutesIndexRouteImport.update({
    id: '/routes/',
    path: '/routes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsIndexRoute =
  AuthenticatedPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersIndexRoute =
  AuthenticatedOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDriversIndexRoute =
  AuthenticatedDriversIndexRouteImport.update({
    id: '/drivers/',
    path: '/drivers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditIndexRoute = AuthenticatedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRoutesRouteIdRoute =
  AuthenticatedRoutesRouteIdRouteImport.update({
    id: '/routes/$routeId',
    path: '/routes/$routeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsPatientIdRoute =
  AuthenticatedPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersUploadRoute =
  AuthenticatedOrdersUploadRouteImport.update({
    id: '/orders/upload',
    path: '/orders/upload',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersOrderIdRoute =
  AuthenticatedOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDriversNewRoute = AuthenticatedDriversNewRouteImport.update({
  id: '/drivers/new',
  path: '/drivers/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDriversDriverIdRoute =
  AuthenticatedDriversDriverIdRouteImport.update({
    id: '/drivers/$driverId',
    path: '/drivers/$driverId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPharmacyIndexRoute =
  AuthenticatedAdminPharmacyIndexRouteImport.update({
    id: '/admin/pharmacy/',
    path: '/admin/pharmacy/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutesRouteIdBuildRoute =
  AuthenticatedRoutesRouteIdBuildRouteImport.update({
    id: '/routes/$routeId_/build',
    path: '/routes/$routeId/build',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPharmacyPharmacyIdRoute =
  AuthenticatedAdminPharmacyPharmacyIdRouteImport.update({
    id: '/admin/pharmacy/$pharmacyId',
    path: '/admin/pharmacy/$pharmacyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/coverage-map': typeof AuthenticatedCoverageMapRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dispatch': typeof AuthenticatedDispatchRoute
  '/exceptions': typeof AuthenticatedExceptionsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/schedule': typeof AuthenticatedScheduleRoute
  '/drivers/$driverId': typeof AuthenticatedDriversDriverIdRoute
  '/drivers/new': typeof AuthenticatedDriversNewRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/orders/upload': typeof AuthenticatedOrdersUploadRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/routes/$routeId': typeof AuthenticatedRoutesRouteIdRoute
  '/audit/': typeof AuthenticatedAuditIndexRoute
  '/drivers/': typeof AuthenticatedDriversIndexRoute
  '/orders/': typeof AuthenticatedOrdersIndexRoute
  '/patients/': typeof AuthenticatedPatientsIndexRoute
  '/routes/': typeof AuthenticatedRoutesIndexRoute
  '/admin/pharmacy/$pharmacyId': typeof AuthenticatedAdminPharmacyPharmacyIdRoute
  '/routes/$routeId/build': typeof AuthenticatedRoutesRouteIdBuildRoute
  '/admin/pharmacy/': typeof AuthenticatedAdminPharmacyIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/coverage-map': typeof AuthenticatedCoverageMapRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dispatch': typeof AuthenticatedDispatchRoute
  '/exceptions': typeof AuthenticatedExceptionsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/schedule': typeof AuthenticatedScheduleRoute
  '/': typeof AuthenticatedIndexRoute
  '/drivers/$driverId': typeof AuthenticatedDriversDriverIdRoute
  '/drivers/new': typeof AuthenticatedDriversNewRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/orders/upload': typeof AuthenticatedOrdersUploadRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/routes/$routeId': typeof AuthenticatedRoutesRouteIdRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/drivers': typeof AuthenticatedDriversIndexRoute
  '/orders': typeof AuthenticatedOrdersIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/routes': typeof AuthenticatedRoutesIndexRoute
  '/admin/pharmacy/$pharmacyId': typeof AuthenticatedAdminPharmacyPharmacyIdRoute
  '/routes/$routeId/build': typeof AuthenticatedRoutesRouteIdBuildRoute
  '/admin/pharmacy': typeof AuthenticatedAdminPharmacyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_authenticated/coverage-map': typeof AuthenticatedCoverageMapRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/dispatch': typeof AuthenticatedDispatchRoute
  '/_authenticated/exceptions': typeof AuthenticatedExceptionsRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/schedule': typeof AuthenticatedScheduleRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/drivers/$driverId': typeof AuthenticatedDriversDriverIdRoute
  '/_authenticated/drivers/new': typeof AuthenticatedDriversNewRoute
  '/_authenticated/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/_authenticated/orders/upload': typeof AuthenticatedOrdersUploadRoute
  '/_authenticated/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/_authenticated/routes/$routeId': typeof AuthenticatedRoutesRouteIdRoute
  '/_authenticated/audit/': typeof AuthenticatedAuditIndexRoute
  '/_authenticated/drivers/': typeof AuthenticatedDriversIndexRoute
  '/_authenticated/orders/': typeof AuthenticatedOrdersIndexRoute
  '/_authenticated/patients/': typeof AuthenticatedPatientsIndexRoute
  '/_authenticated/routes/': typeof AuthenticatedRoutesIndexRoute
  '/_authenticated/admin/pharmacy/$pharmacyId': typeof AuthenticatedAdminPharmacyPharmacyIdRoute
  '/_authenticated/routes/$routeId_/build': typeof AuthenticatedRoutesRouteIdBuildRoute
  '/_authenticated/admin/pharmacy/': typeof AuthenticatedAdminPharmacyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/coverage-map'
    | '/dashboard'
    | '/dispatch'
    | '/exceptions'
    | '/reports'
    | '/schedule'
    | '/drivers/$driverId'
    | '/drivers/new'
    | '/orders/$orderId'
    | '/orders/upload'
    | '/patients/$patientId'
    | '/routes/$routeId'
    | '/audit/'
    | '/drivers/'
    | '/orders/'
    | '/patients/'
    | '/routes/'
    | '/admin/pharmacy/$pharmacyId'
    | '/routes/$routeId/build'
    | '/admin/pharmacy/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/coverage-map'
    | '/dashboard'
    | '/dispatch'
    | '/exceptions'
    | '/reports'
    | '/schedule'
    | '/'
    | '/drivers/$driverId'
    | '/drivers/new'
    | '/orders/$orderId'
    | '/orders/upload'
    | '/patients/$patientId'
    | '/routes/$routeId'
    | '/audit'
    | '/drivers'
    | '/orders'
    | '/patients'
    | '/routes'
    | '/admin/pharmacy/$pharmacyId'
    | '/routes/$routeId/build'
    | '/admin/pharmacy'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/_authenticated/coverage-map'
    | '/_authenticated/dashboard'
    | '/_authenticated/dispatch'
    | '/_authenticated/exceptions'
    | '/_authenticated/reports'
    | '/_authenticated/schedule'
    | '/_authenticated/'
    | '/_authenticated/drivers/$driverId'
    | '/_authenticated/drivers/new'
    | '/_authenticated/orders/$orderId'
    | '/_authenticated/orders/upload'
    | '/_authenticated/patients/$patientId'
    | '/_authenticated/routes/$routeId'
    | '/_authenticated/audit/'
    | '/_authenticated/drivers/'
    | '/_authenticated/orders/'
    | '/_authenticated/patients/'
    | '/_authenticated/routes/'
    | '/_authenticated/admin/pharmacy/$pharmacyId'
    | '/_authenticated/routes/$routeId_/build'
    | '/_authenticated/admin/pharmacy/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedule': {
      id: '/_authenticated/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthenticatedScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exceptions': {
      id: '/_authenticated/exceptions'
      path: '/exceptions'
      fullPath: '/exceptions'
      preLoaderRoute: typeof AuthenticatedExceptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dispatch': {
      id: '/_authenticated/dispatch'
      path: '/dispatch'
      fullPath: '/dispatch'
      preLoaderRoute: typeof AuthenticatedDispatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coverage-map': {
      id: '/_authenticated/coverage-map'
      path: '/coverage-map'
      fullPath: '/coverage-map'
      preLoaderRoute: typeof AuthenticatedCoverageMapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routes/': {
      id: '/_authenticated/routes/'
      path: '/routes'
      fullPath: '/routes/'
      preLoaderRoute: typeof AuthenticatedRoutesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/': {
      id: '/_authenticated/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof AuthenticatedPatientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/': {
      id: '/_authenticated/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/drivers/': {
      id: '/_authenticated/drivers/'
      path: '/drivers'
      fullPath: '/drivers/'
      preLoaderRoute: typeof AuthenticatedDriversIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/': {
      id: '/_authenticated/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthenticatedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routes/$routeId': {
      id: '/_authenticated/routes/$routeId'
      path: '/routes/$routeId'
      fullPath: '/routes/$routeId'
      preLoaderRoute: typeof AuthenticatedRoutesRouteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/$patientId': {
      id: '/_authenticated/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientsPatientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/upload': {
      id: '/_authenticated/orders/upload'
      path: '/orders/upload'
      fullPath: '/orders/upload'
      preLoaderRoute: typeof AuthenticatedOrdersUploadRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/$orderId': {
      id: '/_authenticated/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/drivers/new': {
      id: '/_authenticated/drivers/new'
      path: '/drivers/new'
      fullPath: '/drivers/new'
      preLoaderRoute: typeof AuthenticatedDriversNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/drivers/$driverId': {
      id: '/_authenticated/drivers/$driverId'
      path: '/drivers/$driverId'
      fullPath: '/drivers/$driverId'
      preLoaderRoute: typeof AuthenticatedDriversDriverIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/pharmacy/': {
      id: '/_authenticated/admin/pharmacy/'
      path: '/admin/pharmacy'
      fullPath: '/admin/pharmacy/'
      preLoaderRoute: typeof AuthenticatedAdminPharmacyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routes/$routeId_/build': {
      id: '/_authenticated/routes/$routeId_/build'
      path: '/routes/$routeId/build'
      fullPath: '/routes/$routeId/build'
      preLoaderRoute: typeof AuthenticatedRoutesRouteIdBuildRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/pharmacy/$pharmacyId': {
      id: '/_authenticated/admin/pharmacy/$pharmacyId'
      path: '/admin/pharmacy/$pharmacyId'
      fullPath: '/admin/pharmacy/$pharmacyId'
      preLoaderRoute: typeof AuthenticatedAdminPharmacyPharmacyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCoverageMapRoute: typeof AuthenticatedCoverageMapRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDispatchRoute: typeof AuthenticatedDispatchRoute
  AuthenticatedExceptionsRoute: typeof AuthenticatedExceptionsRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedScheduleRoute: typeof AuthenticatedScheduleRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedDriversDriverIdRoute: typeof AuthenticatedDriversDriverIdRoute
  AuthenticatedDriversNewRoute: typeof AuthenticatedDriversNewRoute
  AuthenticatedOrdersOrderIdRoute: typeof AuthenticatedOrdersOrderIdRoute
  AuthenticatedOrdersUploadRoute: typeof AuthenticatedOrdersUploadRoute
  AuthenticatedPatientsPatientIdRoute: typeof AuthenticatedPatientsPatientIdRoute
  AuthenticatedRoutesRouteIdRoute: typeof AuthenticatedRoutesRouteIdRoute
  AuthenticatedAuditIndexRoute: typeof AuthenticatedAuditIndexRoute
  AuthenticatedDriversIndexRoute: typeof AuthenticatedDriversIndexRoute
  AuthenticatedOrdersIndexRoute: typeof AuthenticatedOrdersIndexRoute
  AuthenticatedPatientsIndexRoute: typeof AuthenticatedPatientsIndexRoute
  AuthenticatedRoutesIndexRoute: typeof AuthenticatedRoutesIndexRoute
  AuthenticatedAdminPharmacyPharmacyIdRoute: typeof AuthenticatedAdminPharmacyPharmacyIdRoute
  AuthenticatedRoutesRouteIdBuildRoute: typeof AuthenticatedRoutesRouteIdBuildRoute
  AuthenticatedAdminPharmacyIndexRoute: typeof AuthenticatedAdminPharmacyIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCoverageMapRoute: AuthenticatedCoverageMapRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDispatchRoute: AuthenticatedDispatchRoute,
  AuthenticatedExceptionsRoute: AuthenticatedExceptionsRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedScheduleRoute: AuthenticatedScheduleRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedDriversDriverIdRoute: AuthenticatedDriversDriverIdRoute,
  AuthenticatedDriversNewRoute: AuthenticatedDriversNewRoute,
  AuthenticatedOrdersOrderIdRoute: AuthenticatedOrdersOrderIdRoute,
  AuthenticatedOrdersUploadRoute: AuthenticatedOrdersUploadRoute,
  AuthenticatedPatientsPatientIdRoute: AuthenticatedPatientsPatientIdRoute,
  AuthenticatedRoutesRouteIdRoute: AuthenticatedRoutesRouteIdRoute,
  AuthenticatedAuditIndexRoute: AuthenticatedAuditIndexRoute,
  AuthenticatedDriversIndexRoute: AuthenticatedDriversIndexRoute,
  AuthenticatedOrdersIndexRoute: AuthenticatedOrdersIndexRoute,
  AuthenticatedPatientsIndexRoute: AuthenticatedPatientsIndexRoute,
  AuthenticatedRoutesIndexRoute: AuthenticatedRoutesIndexRoute,
  AuthenticatedAdminPharmacyPharmacyIdRoute:
    AuthenticatedAdminPharmacyPharmacyIdRoute,
  AuthenticatedRoutesRouteIdBuildRoute: AuthenticatedRoutesRouteIdBuildRoute,
  AuthenticatedAdminPharmacyIndexRoute: AuthenticatedAdminPharmacyIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
